module.exports = __webpack_public_path__ + "img/1@2x(20).4ae23499.png";